module.exports = __webpack_public_path__ + "img/go_to_pdf.de805cf7.svg";